import React, { useLayoutEffect, useEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import TitleNavBarContext from 'context/TitleNavBarContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import AddBtn from 'components/AddBtn';
import { fakeResp } from './respFake';
import PaginationComp from 'components/Pagination';
import ListDynamicShowCase from 'components/ListDynamicShowCase';
import FormDynamicShowCase from 'components/FormDynamicShowCase';
import { DynamicShowCaseProps } from 'types/DynamicShowCaseProps';
import { getDynamicShowCase } from './reqs';

export default function DynamicShowCase() {
	const { i18n, t }: UseTranslationProps = useTranslation();
	const { setDataAbouTitle } = useContext(TitleNavBarContext);
	const { handleNotify } = useContext(SystemNotifyContext);

	const [isFormOpen, setIsFormOpen] = useState(false);
	const [isLoad, setIsload] = useState(false);
	const [actualPage, setActualPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [showCaseToEdit, setShowCaseToEdit] =
		useState<null | DynamicShowCaseProps>(null);
	const [listMenuItensLocation, setListMenuItensLocation] = useState<
		DynamicShowCaseProps[]
	>(fakeResp.data.pagesPaginated.data);

	//busca páginas dinâmicas de acordo com a página atual
	useEffect(() => {
		(async () => {
			setIsload(true);
			await getDynamicShowCase(
				setListMenuItensLocation,
				setActualPage,
				setTotalPages,
				actualPage,
				handleNotify
			);

			setIsload(false);
		})();
	}, [actualPage]);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({
			...value,
			title: 'navBarOptions.dynamicShowcase'
		}));
	}, [i18n?.language]);

	return (
		<S.container>
			<AddBtn
				anyFunction={() => {
					setIsFormOpen(true);
				}}
				text={t('dynamicShowCase.addNewShowcase')}
			/>

			<ListDynamicShowCase
				isLoad={isLoad}
				listDynamicShowCase={listMenuItensLocation}
				setDynamicShowcaseToEdit={setShowCaseToEdit}
				setIsOpen={setIsFormOpen}
				setListMenuItensLocation={setListMenuItensLocation}
				setActualPage={setActualPage}
				setTotalPages={setTotalPages}
				actualPage={actualPage}
			/>

			<PaginationComp
				qtdPages={totalPages}
				getActualPage={setActualPage}
				actualPage={actualPage}
			/>
			{isFormOpen && (
				<FormDynamicShowCase
					setListMenuItensLocation={setListMenuItensLocation}
					setActualPage={setActualPage}
					setTotalPages={setTotalPages}
					isOpen={isFormOpen}
					setIsOpen={setIsFormOpen}
					showCaseToEdit={showCaseToEdit}
					setShowCaseToEdit={setShowCaseToEdit}
					actualPage={actualPage}
				/>
			)}
		</S.container>
	);
}
